import template from './wizard_leave_setup_holidays.html';
import tr from '../../lib/default-translator.js';

class WizardLeaveSetupHolidays
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable(null); 
		this.holiday_types = ko.observableArray();
		this.holiday_rules = ko.observableArray();
		this.holiday_type = ko.observable();
		this.holiday_rule = ko.observable();
		this.priority = ko.observable(1); 
		this.leave_type_linked_holidays = ko.observableArray();
		this.ignore_holidays = ko.observable(false); 
		this.ignore_weekends = ko.observable(false); 
	}

	close()
	{
		this.dialog.close();
	}

	async back_wizard()
	{
		if (this.leave_type_id())
		{
			this.dialog.close();
			//await Grape.dialog.open('WizardLeaveSetupOverview', {leave_type_id: this.leave_type_id()});
			return;
		}

		let data = Object.assign({}, this.dialog.bindings, {
			leave_type_linked_holidays: this.leave_type_linked_holidays(),
			ignore_holidays: this.ignore_holidays(),
			ignore_weekends: this.ignore_weekends()
		});
		
		this.dialog.close();
		await Grape.dialog.open('WizardLeaveSetupRoles', data);
	}

	async edit_holidays()
	{
		let data = this.holiday_types().find(x => x.holiday_type === this.holiday_type());
		await Grape.dialog.open('WizardHolidaySetup', data);
		await this.dialog.updateData();
	}

	async next_wizard()
	{
		let data = Object.assign({}, this.dialog.bindings, {
			leave_type_linked_holidays: this.leave_type_linked_holidays(),
			ignore_holidays: this.ignore_holidays(),
			ignore_weekends: this.ignore_weekends()
		});
		
		this.dialog.close();
		await Grape.dialog.open('WizardLeaveSetupRestrictions', data);
	}

	async add_new_holiday_type()
	{
		let d = await Grape.dialog.open('AdminAddNewHolidayType', {wizard: true});
		await this.dialog.updateData();
		if (d && d.holiday_type)
			this.holiday_type(d.holiday_type);
	}

	link_holiday_type()
	{
		//validation: priority > 0 
		if (this.priority() <= 0 || this.priority() % 1 != 0)
		{
			Grape.alerts.alert({type: 'error', message: tr('The priority must be a positive integer value'), title: tr('Error')});
			return;
		}

		let holiday_type = {
			holiday_type: this.holiday_type(),
			priority: this.priority(),
			holiday_rule: this.holiday_rule()
		};
		this.leave_type_linked_holidays.push(holiday_type);
	}

	remove_linked_leave(v, e)
	{
		let linked_holidays = this.leave_type_linked_holidays();
		let filtered = linked_holidays.filter((n) => n.holiday_type !== v.holiday_type);
		this.leave_type_linked_holidays(filtered);
	}

	async back_and_save() 
	{
		// Update the leave_object with current values
		this.dialog.bindings.leave_object.leave_type_linked_holidays = this.leave_type_linked_holidays();
		this.dialog.bindings.leave_object.ignore_holidays = this.ignore_holidays();
		this.dialog.bindings.leave_object.ignore_weekends = this.ignore_weekends();
		
		// Save the leave_object
		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.dialog.bindings.leave_object);

		if (res.status === 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Changes has been saved'), title: tr('Success')});
			this.dialog.close();
		}
	}
}

class WizardLeaveSetupHolidaysPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupHolidays(this);
	}

	async init()
	{
		console.log('bindings', this.bindings);
		
		// Apply bindings - check leave_object first, then fallback to direct binding
		if (this.bindings.leave_object?.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_object.leave_type_id);
		else if (this.bindings.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id);

		// Handle leave_type_linked_holidays
		if (this.bindings.leave_object?.leave_type_linked_holidays)
			this.viewModel.leave_type_linked_holidays(this.bindings.leave_object.leave_type_linked_holidays);
		else if (this.bindings.leave_type_linked_holidays)
			this.viewModel.leave_type_linked_holidays(this.bindings.leave_type_linked_holidays);
		
		// Handle ignore_holidays (with null/undefined check)
		if (this.bindings.leave_object?.ignore_holidays != null)
			this.viewModel.ignore_holidays(this.bindings.leave_object.ignore_holidays);
		else if (this.bindings.ignore_holidays != null)
			this.viewModel.ignore_holidays(this.bindings.ignore_holidays);

		// Handle ignore_weekends (with null/undefined check)
		if (this.bindings.leave_object?.ignore_weekends != null)
			this.viewModel.ignore_weekends(this.bindings.leave_object.ignore_weekends);
		else if (this.bindings.ignore_weekends != null)
			this.viewModel.ignore_weekends(this.bindings.ignore_weekends);

		await this.updateData();
	}

	async updateData()
	{
		let res_types = await Grape.fetches.getJSON('/api/record', {
			table: 'holiday_types',
			schema: 'public'
		});

		if (res_types.status !== 'ERROR')
		{
			if (res_types.records)
				this.viewModel.holiday_types(res_types.records);
		}

		let res_rules = await Grape.fetches.getJSON('/api/record', {
			table: 'holiday_rules',
			limit: 1000000
		});

		if (res_rules.status !== 'ERROR')
		{
			if (res_rules.records)
				this.viewModel.holiday_rules(res_rules.records);
		}
	}
}

export default {
	name: 'WizardLeaveSetupHolidays',
	dialog_class: WizardLeaveSetupHolidaysPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_holidays',
	provider: 'ps'
};